/**
 AgencySearchService.js
 Sending Post-Requests to https://www.oeffentliche.de/content/beratersuche/index.html
 and receiving the response.
 Possible parameter values:
 - searchMethod: BY_LOCATION | BY_NAME
 - query: (name or zip+city)
 - autoSuggestCat: "zipcode" (if BY_NAME) | "agency" (if BY_LOCATION)
 -
 */


async function getSuggestionList(searchMethod,query){
        var myHeaders = new Headers();
        myHeaders.append("form-identifier", "advisorAutocompleteAjax");
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("Cookie", "DIGIJSESSIONID=C9332494FB54EC7E25BF936B4D594DFA.digipoc01; SERVERID=i-JPQE2Z5U|Xp79F");

        var urlencoded = new URLSearchParams();
        urlencoded.append("query", query);
        urlencoded.append("searchMethod", searchMethod);
        urlencoded.append("kanal", "0");

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: urlencoded,
            redirect: 'follow'
        };

        let response = await fetch("https://www.oeffentliche.de/content/beratersuche/", requestOptions);
        return response.json();
    }

async function getAgencyList(searchMethod,query,autoSuggest=true){
    let target = 'https://www.oeffentliche.de/content/beratersuche/index.html';
    // target = 'https://4g.cleverads.de/web/4g/sk_test/fakeResponseForListSelect.php';
    let autoSuggestCat = 'zipcode';
    if(searchMethod==='BY_LOCATION') { autoSuggestCat = 'agency'; }
    var myHeaders = new Headers();
    myHeaders.append("form-identifier", "interaktiveBeratersucheAjax");
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append("Cookie", "DIGIJSESSIONID=0865806E2CCF6FC66F7DC01AFC1DA517.digipoc01; SERVERID=i-JPQE2Z5U|Xp9Mt");

    var urlencoded = new URLSearchParams();
    urlencoded.append("query", query);
    urlencoded.append("searchMethod", searchMethod);
    urlencoded.append("kanal", "0");
    urlencoded.append("structuredContentId", "3606e2cc-9f15-11e7-be32-52540aa5470d");
    urlencoded.append("beraterauswahl", "false");
    urlencoded.append("searchTrigger", "textfield");
    urlencoded.append("autoSuggest", "true");
    urlencoded.append("autoSuggestCat", autoSuggestCat);
    urlencoded.append("widgetReferral", "interaktive-beratersuche");

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
    };

    let response = await fetch("https://www.oeffentliche.de/content/beratersuche/index.html", requestOptions);
    return response.json();
}

export { getSuggestionList, getAgencyList };
